import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Features from './pages/Features';
import HowItWorks from './pages/HowItWorks';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Download from './pages/Download';
import AppAuth from './pages/AppAuth';
import Dmca from './pages/Dmca';
import Signup from './pages/Signup';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Settings from './pages/Settings';
import Admin from './pages/Admin';
import OptinProof from './pages/OptinProof';
import SmsPolicy from './pages/SmsPolicy';
import OptOut from './pages/OptOut';
import SignupProof from './pages/SignupProof';
import CrmLayout from './pages/crm/CrmLayout';
import CrmDashboard from './pages/crm/CrmDashboard';
import CrmListings from './pages/crm/CrmListings';
import CrmClients from './pages/crm/CrmClients';
import CrmAppointments from './pages/crm/CrmAppointments';
import CrmInbox from './pages/crm/CrmInbox';
import CrmBlasts from './pages/crm/CrmBlasts';
import CrmSettingsVoice from './pages/crm/CrmSettingsVoice';
import CrmSettingsBooking from './pages/crm/CrmSettingsBooking';
import CrmSettingsProfessionals from './pages/crm/CrmSettingsProfessionals';
import CrmSettingsTextMessaging from './pages/crm/CrmSettingsTextMessaging';
import CrmSettingsSocialMedia from './pages/crm/CrmSettingsSocialMedia';
import CrmLiveCalls from './pages/crm/CrmLiveCalls';
import CrmAdminVoiceNumbers from './pages/crm/CrmAdminVoiceNumbers';
import CrmAdminAiScripts from './pages/crm/CrmAdminAiScripts';
import CrmAdminMeta from './pages/crm/CrmAdminMeta';
import Billing from './pages/Billing';
import Subscribe from './pages/Subscribe';
import ScrollToTop from './components/ScrollToTop';
import RequireAuth from './components/RequireAuth';
import SmsOptInModal from './components/SmsOptInModal';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';

const STANDALONE_ROUTES = ['/optin-proof', '/sms-policy', '/signup/proof'];

function Chrome({ children }) {
  const { pathname } = useLocation();
  if (STANDALONE_ROUTES.includes(pathname)) return <>{children}</>;
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <SmsOptInModal />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/features" element={<Features />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/download" element={<Download />} />
              <Route path="/app-auth" element={<AppAuth />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
              <Route path="/billing" element={<RequireAuth><Billing /></RequireAuth>} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/admin" element={<RequireAuth requireAdmin><Admin /></RequireAuth>} />
              <Route path="/crm" element={<RequireAuth><CrmLayout /></RequireAuth>}>
                <Route index element={<CrmDashboard />} />
                <Route path="listings" element={<CrmListings />} />
                <Route path="clients" element={<CrmClients />} />
                <Route path="appointments" element={<CrmAppointments />} />
                <Route path="inbox" element={<CrmInbox />} />
                <Route path="blasts" element={<CrmBlasts />} />
                <Route path="settings/voice" element={<CrmSettingsVoice />} />
                <Route path="settings/booking" element={<CrmSettingsBooking />} />
                <Route path="settings/professionals" element={<CrmSettingsProfessionals />} />
                <Route path="settings/text-messaging" element={<CrmSettingsTextMessaging />} />
                <Route path="settings/social-media" element={<CrmSettingsSocialMedia />} />
                <Route path="live-calls" element={<CrmLiveCalls />} />
                <Route path="admin/voice-numbers" element={<CrmAdminVoiceNumbers />} />
                <Route path="admin/ai-scripts" element={<CrmAdminAiScripts />} />
                <Route path="admin/meta" element={<CrmAdminMeta />} />
              </Route>
              <Route path="/terms" element={<Terms />} />
              <Route path="/dmca" element={<Dmca />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/opt-out" element={<OptOut />} />
              <Route path="/optin-proof" element={<OptinProof />} />
              <Route path="/sms-policy" element={<SmsPolicy />} />
              <Route path="/signup/proof" element={<SignupProof />} />
            </Routes>
          </Chrome>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
